import React from "react";
import { NavLink } from "react-router-dom";

export const OrganisationsLinks = () => {
    return (
        <div className="links">
            <NavLink to="/organisations/catechism" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>Catechism</NavLink>
            <NavLink to="/organisations/kcym" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>K.C.Y.M</NavLink>
            <NavLink to="/organisations/clc" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>C.L.C</NavLink>
            <NavLink to="/organisations/vayojanasagam" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>VayojanaSagam</NavLink>
            <NavLink to="/organisations/mathrevedi" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>Mathrevedi</NavLink>
            <NavLink to="/organisations/altarboys" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>Altar Boys</NavLink>
            <NavLink to="/organisations/choir" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>Church Choir</NavLink>
        </div>
    )
};